
import axios from '../js/ajax'

/** 获取下载页信息 */
export const getAction = params => axios.get('/qrCode/getAction', {params});
/** 获取下载页信息 */
export const getReplyMessageAction = params => axios.get('/qrCode/getReplyMessageAction', {params});

/** 获取微信公众号授权 */
export const weChatPublicAuthLogin = params => axios.post('/weChatPublicAuthLogin', params);

/** 点击单选页选项 */
export const singlePageClick = params => axios.get('/qrCode/singlePageClick', {params});
/** 获取中间域名 */
export const getCallBackDomain = (params) => axios.get('/qrCode/getCallBackDomain', {params})
// 入口域名获取域名
export const getRedirectParam = (params) => axios.get('/qrCode/getRedirectParam', {params})
/** 检测cookie */
export const checkSession = (params) => axios.get('/qrCode/checkSession', {params})
/** 清除cookie */
export const printCookie = (params) => axios.get('/qrCode/printCookie', {params})
/** 钱收收授权登录 */
export const handleLoginApplication = (params) => axios.post('/loginApplication/handleLoginApplication', params)
/** 获取同一个session下的token */
export const getTokenFromSession = (params) => axios.get('/user/getTokenFromSession', params)
